export enum EAlertNotice {
  GOT_IT = 'GOT_IT',
  CHECK_SEJAM = 'CHECK_SEJAM',
}
